<template>
 <div class="library_filter_section">
    <input type="checkbox" id="year" class="library-filter-show-hide-input hidden">
    <label class="library-filter-label" for="year">Filter by year</label>
    <div class="library_filter_items">
       <div v-for="year in yearsReduced" :key="year" class="library_filter_item">
           <library-filter-button :item-id="year" :item-value="year" :item-title="year"  @updated="update"></library-filter-button>
       </div>
    <div class="library_filter_item flex_fix"></div>
    </div>
    </div>
</template>

<script>

    export default {
       data() {
           return {
               checkedYears: [],
           }
       },
       props: {
           years: {
               required: true,
               type: Array,
           },
       },
       computed: {
           yearsReduced: function() {
               if (this.years.length > 11) {
                   let years = this.years.slice(0,11);
                   years.push('Pre '+this.years[4]);
                   return years;
               }
               return this.years;
           }
       },
       methods: {
           update(payload){
               this.checkedYears = this.checkedYears.filter(el=>el!=payload.item);
               if (payload.active) { this.checkedYears.push(payload.item); }
               this.$emit('yearsChanged',this.checkedYears);
           }
       }

    }
</script>
